{
  "PENDING": "Na čekanju",
  "PROCESSING": "U obradi",
  "PAID": "Plaćeno",
  "COMPLETED": "Završeno",
  "FAILED": "Neuspješno",
  "SKIPPED": "Preskočeno",
  "RUNNING": "U toku",
  "CANCELLED": "Otkazano",
  "SUCCESS": "Uspješno",
  "FAILURE": "Neuspješno"
}
